import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { TenantPaginateResponse } from "../typings/tenant";
import { BaseFiltroPaginate } from "core/resources/enums/paginate";

function useGetTenants({
  page = 1,
  limit = BaseFiltroPaginate.Limit,
  search = undefined,
  tenant = undefined,
}: PaginateQuery & { tenant?: string }) {
  return useQuery([`/v1/tenants-${page}-${limit}-${search}`], async () => {
    const res = await axios.get<PaginateResult<TenantPaginateResponse>>(
      "/v1/tenants",
      {
        params: {
          page,
          limit,
          search,
        },
        headers: { tenant },
      }
    );

    return res.data;
  });
}

export default useGetTenants;
